import {
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  FormsModule
} from '@angular/forms';

import {
  Quarto,
  QuartoService
} from '../../../service/quarto.service';

import {
  TarifaQuartoData,
  TarifaQuartoDataDTO,
  TarifaQuartoDataService
} from '../../../service/tarifaQuartoDataService';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-tarifas-data',

  standalone: true,

  imports: [
    CommonModule,
    FormsModule
  ],

  templateUrl: './tarifas-data.component.html',

  styleUrl: './tarifas-data.component.css'
})
export class TarifasDataComponent
  implements OnInit {

  quartos: Quarto[] = [];

  tarifas: TarifaQuartoData[] = [];

  carregando = false;

  salvando = false;

  modalAberto = false;

  modoEdicao = false;

  quartoSelecionado: Quarto | null = null;

  dataSelecionada = '';

  tarifasFormulario: {
    [quantidade: number]: number | null;
  } = {};


  constructor(
    private tarifaService: TarifaQuartoDataService,

    private quartoService: QuartoService,

    private cdr: ChangeDetectorRef
  ) {}


  ngOnInit(): void {

    this.carregarQuartos();

  }


  carregarQuartos(): void {

    this.carregando = true;

    this.quartoService
      .listar()
      .subscribe({

        next: (quartos: Quarto[]) => {

          this.quartos = quartos;

          if (this.quartos.length > 0) {

            this.quartoSelecionado =
              this.quartos[0];

            this.inicializarTarifas();

            this.carregarTarifas();

          } else {

            this.carregando = false;

          }

          this.cdr.detectChanges();

        },

        error: (erro: any) => {

          console.error(
            'Erro ao carregar acomodações:',
            erro
          );

          this.carregando = false;

          this.cdr.detectChanges();

        }

      });

  }


  carregarTarifas(): void {

    if (!this.quartoSelecionado) {

      this.carregando = false;

      return;

    }

    this.carregando = true;

    this.tarifaService
      .listar(
        this.quartoSelecionado.id
      )
      .subscribe({

        next: (tarifas: TarifaQuartoData[]) => {

          this.tarifas = tarifas;

          this.carregando = false;

          this.cdr.detectChanges();

        },

        error: (erro: any) => {

          console.error(
            'Erro ao carregar tarifas:',
            erro
          );

          this.tarifas = [];

          this.carregando = false;

          this.cdr.detectChanges();

        }

      });

  }


  trocarQuarto(): void {

    if (!this.quartoSelecionado) {
      return;
    }

    this.tarifas = [];

    this.inicializarTarifas();

    this.carregarTarifas();

    this.cdr.detectChanges();

  }


  abrirModalCadastro(): void {

    if (!this.quartoSelecionado) {
      return;
    }

    this.modoEdicao = false;

    this.modalAberto = true;

    this.dataSelecionada = '';

    this.inicializarTarifas();

    this.cdr.detectChanges();

  }


  inicializarTarifas(): void {

    this.tarifasFormulario = {};

    if (!this.quartoSelecionado) {
      return;
    }

    /*
     * Cria exatamente a quantidade
     * de campos correspondente à
     * capacidade da acomodação.
     *
     * Exemplo:
     *
     * capacidade 2 → 1 e 2 hóspedes
     * capacidade 4 → 1, 2, 3 e 4 hóspedes
     */

    for (
      let quantidade = 1;
      quantidade <= this.quartoSelecionado.capacidade;
      quantidade++
    ) {

      this.tarifasFormulario[
        quantidade
        ] = null;

    }

    this.cdr.detectChanges();

  }


  abrirModalEdicao(
    data: string
  ): void {

    if (!this.quartoSelecionado) {
      return;
    }

    const tarifasData =
      this.tarifas.filter(
        tarifa =>
          tarifa.data === data
      );

    if (tarifasData.length === 0) {
      return;
    }

    this.modoEdicao = true;

    this.modalAberto = true;

    this.dataSelecionada = data;

    this.inicializarTarifas();

    tarifasData.forEach(
      tarifa => {

        /*
         * Só preenche valores que
         * estejam dentro da capacidade
         * atual da acomodação.
         */

        if (
          tarifa.quantidadeHospedes >= 1 &&
          tarifa.quantidadeHospedes <=
          (this.quartoSelecionado?.capacidade || 0)
        ) {

          this.tarifasFormulario[
            tarifa.quantidadeHospedes
            ] = tarifa.valor;

        }

      }
    );

    this.cdr.detectChanges();

  }


  fecharModal(): void {

    if (this.salvando) {
      return;
    }

    this.modalAberto = false;

    this.cdr.detectChanges();

  }


  salvar(): void {

    if (!this.quartoSelecionado) {
      return;
    }

    if (!this.dataSelecionada) {

      Swal.fire({
        icon: 'warning',
        title: 'Data não informada',
        text: 'Informe a data da tarifa.',
        confirmButtonText: 'Entendi',
        confirmButtonColor: '#173b63'
      });

      return;
    }


    const tarifas: {
      [quantidade: number]: number;
    } = {};


    for (
      let quantidade = 1;
      quantidade <= this.quartoSelecionado.capacidade;
      quantidade++
    ) {

      const valor =
        this.tarifasFormulario[
          quantidade
          ];


      if (
        valor === null ||
        valor === undefined ||
        Number(valor) <= 0
      ) {

        Swal.fire({
          icon: 'warning',
          title: 'Valor não informado',
          text:
            `Informe o valor da diária para ${quantidade} hóspede(s).`,
          confirmButtonText: 'Entendi',
          confirmButtonColor: '#173b63'
        });

        return;
      }


      tarifas[quantidade] =
        Number(valor);

    }


    const dto: TarifaQuartoDataDTO = {

      quartoId:
      this.quartoSelecionado.id,

      data:
      this.dataSelecionada,

      tarifas

    };


    this.salvando = true;

    this.cdr.detectChanges();


    const requisicao =
      this.modoEdicao
        ? this.tarifaService.editar(dto)
        : this.tarifaService.salvar(dto);


    requisicao.subscribe({

      next: () => {

        this.salvando = false;

        this.modalAberto = false;

        this.cdr.detectChanges();

        this.carregarTarifas();


        Swal.fire({
          icon: 'success',
          title: this.modoEdicao
            ? 'Tarifa atualizada!'
            : 'Tarifa cadastrada!',
          text: this.modoEdicao
            ? 'A tarifa especial foi atualizada com sucesso.'
            : 'A tarifa especial foi cadastrada com sucesso.',
          confirmButtonText: 'OK',
          confirmButtonColor: '#173b63'
        });

      },


      error: (erro: any) => {

        console.error(
          'Erro ao salvar tarifa:',
          erro
        );

        this.salvando = false;

        this.cdr.detectChanges();


        Swal.fire({
          icon: 'error',
          title: 'Erro ao salvar',
          text:
            erro?.error?.message ||
            'Não foi possível salvar a tarifa.',
          confirmButtonText: 'OK',
          confirmButtonColor: '#173b63'
        });

      }

    });

  }


  excluir(data: string): void {

    if (!this.quartoSelecionado) {
      return;
    }

    Swal.fire({
      title: 'Excluir tarifa?',
      text: `Deseja excluir a tarifa especial do dia ${this.formatarData(data)}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d'
    }).then((resultado) => {

      if (!resultado.isConfirmed) {
        return;
      }

      const tarifasData = this.tarifas.filter(
        tarifa => tarifa.data === data
      );

      if (tarifasData.length === 0) {
        return;
      }

      this.salvando = true;
      this.cdr.detectChanges();

      let concluidos = 0;

      tarifasData.forEach((tarifa) => {

        this.tarifaService.excluir(tarifa.id).subscribe({

          next: () => {

            concluidos++;

            if (concluidos === tarifasData.length) {

              this.salvando = false;
              this.cdr.detectChanges();

              this.carregarTarifas();

              Swal.fire({
                title: 'Excluído!',
                text: 'A tarifa especial foi excluída com sucesso.',
                icon: 'success',
                confirmButtonText: 'OK',
                confirmButtonColor: '#696A49'
              });

            }

          },

          error: (erro: any) => {

            console.error(
              'Erro ao excluir tarifa:',
              erro
            );

            this.salvando = false;
            this.cdr.detectChanges();

            Swal.fire({
              title: 'Erro!',
              text: 'Não foi possível excluir a tarifa.',
              icon: 'error',
              confirmButtonText: 'OK',
              confirmButtonColor: '#696A49'
            });

          }

        });

      });

    });

  }


  agruparPorData(): string[] {

    const datas =
      this.tarifas.map(
        tarifa =>
          tarifa.data
      );


    return [
      ...new Set(datas)
    ];

  }


  obterTarifa(
    data: string,
    quantidade: number
  ): number | null {

    const tarifa =
      this.tarifas.find(
        item =>
          item.data === data &&
          item.quantidadeHospedes === quantidade
      );


    return tarifa
      ? tarifa.valor
      : null;

  }


  formatarData(
    data: string
  ): string {

    if (!data) {
      return '';
    }


    const partes =
      data.split('-');


    if (partes.length !== 3) {
      return data;
    }


    return `${partes[2]}/${partes[1]}/${partes[0]}`;

  }

}
